<template>
    <footer :class="[isLight ? 'lightmode' : 'darkmode']">
        <p>© 2026 Untitled 9. All rights reserved. </p>
        <p>Stable 2.0.1</p>
    </footer>
</template>

<script setup></script>

<style scoped>
    footer
    {
        font-family: Syne;
        font-size: clamp(0.67rem,13vw - 2rem,1rem);
        height:50px;
        display:flex;
        padding:0 9px;
        justify-content: space-between;
        align-items: center;
        user-select: none;
        background-color: #5F8B4C;
        color: #F7F7F6;
        grid-area: 3 / 1 / 4 / 2;
    }

    footer p
    {
        margin:0;
    }
</style>